import { render, staticRenderFns } from "./FilterProject.vue?vue&type=template&id=2e45906a&scoped=true&"
import script from "./FilterProject.vue?vue&type=script&lang=ts&"
export * from "./FilterProject.vue?vue&type=script&lang=ts&"
import style0 from "./FilterProject.vue?vue&type=style&index=0&id=2e45906a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e45906a",
  null
  
)

export default component.exports